import { useState, useEffect, type ChangeEvent } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TextField } from "@mui/material";
import type { ApplicationFormSlice, Customer, UserDetailsState } from "@/store/slices/types/applicationFormSlice";
import {
  customersSelector,
  updateCreditProfile,
  userDetailsSelector,
  // @ts-expect-error: ignoring as it is existing js file
} from "@/store/slices/applicationFormSlice";

interface QuoteCreditScoreProps {
  applicationId: string;
  disabled: boolean;
}

const QuoteCreditScore = ({ applicationId, disabled }: QuoteCreditScoreProps) => {
  const dispatch = useDispatch();
  const customers = useSelector<ApplicationFormSlice, Customer[]>(customersSelector);
  const { isNewApplication } = useSelector<ApplicationFormSlice, UserDetailsState>(userDetailsSelector);
  // Quote credit score is captured against the first customer in the quote flow.
  const firstCustomer = customers?.[0];
  const [scoreValue, setScoreValue] = useState(firstCustomer?.creditProfile?.score);

  function handleScore(event: ChangeEvent<HTMLInputElement>) {
    setScoreValue(event.target.value);
  }

  function updateCreditScore(value: string) {
    dispatch(
      updateCreditProfile({
        applicationId,
        score: value,
        customer: firstCustomer?._id,
      }),
    );
  }

  useEffect(() => {
    if (firstCustomer?.creditProfile?.score) setScoreValue(firstCustomer.creditProfile.score);
  }, [firstCustomer?.creditProfile?.score]);

  useEffect(() => {
    if (isNewApplication) setScoreValue("");
  }, [isNewApplication]);

  return (
    <TextField
      fullWidth
      className="eight-step"
      variant="filled"
      defaultValue=""
      type="number"
      name="creditscore"
      label="Score"
      size="small"
      placeholder="650"
      value={scoreValue || ""}
      onChange={handleScore}
      onBlur={async (event) => {
        if (event.target.value !== firstCustomer?.creditProfile?.score?.toString()) {
          updateCreditScore(event.target.value);
        }
      }}
      disabled={disabled}
    />
  );
};

export default QuoteCreditScore;
